import { useLanguage } from '@/contexts/LanguageContext';

export const useRouteDisplay = () => {
  const { isRTL } = useLanguage();

  const formatRoute = (pickupCity: string, dropCity: string) => {
    if (isRTL) {
      // For RTL (Arabic): show as "dropCity ← pickupCity" (swap order and use left arrow)
      return `${dropCity} ← ${pickupCity}`;
    } else {
      // For LTR (English): show as "pickupCity → dropCity"
      return `${pickupCity} → ${dropCity}`;
    }
  };

  const getRouteArrow = () => {
    return isRTL ? '←' : '→';
  };

  const formatRouteWithArrow = (pickupCity: string, dropCity: string) => {
    if (isRTL) {
      // For RTL: swap cities and use left arrow
      return { fromCity: dropCity, toCity: pickupCity, arrow: '←' };
    } else {
      // For LTR: keep normal order and use right arrow
      return { fromCity: pickupCity, toCity: dropCity, arrow: '→' };
    }
  };

  return { formatRoute, getRouteArrow, formatRouteWithArrow };
};